import { TCMResponseDataItem, TCMResponseItem, TCMResponseItemService } from "@nt-portal/tcm-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { ResultData } from "@nt-portal/common-sdk";


export interface TCMResponseItemOptions extends ControllerOptions<TCMResponseItem> {
    sheetId: string;
    goals?: boolean;
}

export const initTCMResponseItem = (inObj: Partial<TCMResponseItem>) => {
    let item: TCMResponseItem = {
        id: "",
        ranking: 0,
        price: 0,
        createdBy: ""
    }
    return item;
}


export class ClientTCMResponseItemService extends BaseClientService implements DataController<TCMResponseItem> {

    private _service: TCMResponseItemService;


    constructor() {
        super();
        this._service = new TCMResponseItemService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public set params(params: any) {
        this._service.params = params;
    }

    public get params() {
        return this._service.params ?? {};
    }

    public async get(options: TCMResponseItemOptions): Promise<ResultData<TCMResponseItem>> {

        if (this.params.responseId) {
            return await this._service.getByFilter(this.buildFetchParams(options), this.token, options.sheetId, options.filter, options.goals);
        } else {
            throw new Error("Response ID is required to fetch response items.");
        }
    }

    public async update(options: TCMResponseItemOptions): Promise<TCMResponseItem | TCMResponseItem[] | null> {
        if (options.item && options.item.id && this.params.responseId)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
}
